import { RegistryStatus } from '../domain/types';

export const registryStatusLabels: { [key in RegistryStatus]: string } = {
  [RegistryStatus.LIBERO]: 'Libero',
  [RegistryStatus.OCCUPATO]: 'Occupato',
};
